//Creamos la variable de catalogos
const sistemas = {}


//Importación de librerias
import Forseti from '../js/sistemas/forseti.js';
import SISETA from '../js/sistemas/siseta.js';
import SINOJ from '../js/sistemas/sinoj.js';



//Asignamos los datos en sistemas
crearLasRutasDeLosSistemas(Forseti);
crearLasRutasDeLosSistemas(SISETA);
crearLasRutasDeLosSistemas(SINOJ);


//Exportamos los datos de común
export default sistemas;


//Se define la función que se encargara de hacer el listado de todos los paths
function crearLasRutasDeLosSistemas(datosDeLosPaths) {
  for (let i = 0; i < datosDeLosPaths.length; i++) {
    if (sistemas[datosDeLosPaths[i].Proviene] === undefined || sistemas[datosDeLosPaths[i].Proviene] === null)
      sistemas[datosDeLosPaths[i].Proviene] = {}
    sistemas[datosDeLosPaths[i].Proviene][datosDeLosPaths[i].Nombre] = datosDeLosPaths[i].datos;
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/sistemas.js
// module id = null
// module chunks = 